import { generateId } from '@ztechapps/common.utils'

/**
 * Mints an unguessable slug for a blog preview URL. Preview links carry no
 * login and never expire, so the slug is the only secret — it uses the shared
 * unguessable-id minter and is rotated by saving a new one on the post.
 */
export const mintBlogPreviewSlug = (): string => generateId()
